import React from "react";
import { useHistory } from "react-router-dom";
//Limitless imports
import { ClientContext } from "@limitless/common/utils";
import { useResources } from "@limitless/common/hooks";
import { HowItWorksCarousel } from "@limitless/customer/components";
import { useCustomerContext, useCustomerMessageContext } from "@limitless/customer/hooks";
import { useAppVisibilityContext } from "../hooks/app-visibility/AppVisibilityContext";
import { useMobileDetectionContext } from "../hooks/mobile-detection/MobileDetectionContext";
import { usePageViewRecorder } from "@limitless/analytics/hooks/AnalyticsPageViewRecorderHook";

const HowItWorksScreen = () => {
    const { toggleAppOpen } = useAppVisibilityContext();
    const { isMobileDevice } = useMobileDetectionContext();
    const history = useHistory();
    const { customer, updateHIWViewedStatus, updateAutoSubmit } = useCustomerContext();
    const { message } = useCustomerMessageContext();
    const { hiwViewed } = customer;
    const {
        resources: { hiwSlides }
    } = useResources();

    usePageViewRecorder("HowItWorksScreen");

    React.useMemo(() => {
        if (ClientContext._hiwMode === "disabled") {
            history.push("/createMessage");
        } else {
            if (hiwViewed) {
                history.push("/createMessage");
            }
        }
    }, []);

    const navigate = () => {
        switch (customer.postHiwAction) {
            case "auto-submit":
                updateAutoSubmit(true);
                history.push("/createMessage");
                break;
            case "conversation":
                history.push(`/conversation/${message.messageId}/${message.accessKey}/${false}`);
                break;
            default:
                history.push("/createMessage");
        }

        updateHIWViewedStatus(true);
    };

    const mandatory = ClientContext._hiwMode === "mandatory" ? true : false;

    return (
        <div className="llm-view-container">
            <HowItWorksCarousel
                slides={hiwSlides}
                mandatory={mandatory}
                onNavigate={navigate}
                onClose={toggleAppOpen}
                isMobileDevice={isMobileDevice}
            />
        </div>
    );
};

export default HowItWorksScreen;
